export function getLocalizedString(label) {
  const language = localStorage.getItem("B2BLanguage");
  let localized = "";

  switch (label) {
    case "ERROR_AUTH":
      localized =
        language === "ENG"
          ? "Authentication error."
          : "Errore di autenticazione.";
      break;
    case "ERROR_403":
      localized =
        language === "ENG" ? "Unauthorized user." : "Utente non autorizzato.";
      break;
    case "ERROR_USER_LOCKED":
      localized =
        language === "ENG"
          ? "The service is suspended and we invite you to contact the sales representative."
          : "Il servizio è sospeso e ti invitiamo a contattare il commerciale.";
      break;
    case "ERROR_404":
      localized =
        language === "ENG" ? "Object not found." : "Oggetto non trovato.";
      break;
    case "ERROR_500":
      localized =
        language === "ENG"
          ? "Ooops! Something went wrong."
          : "Ooops! Qualcosa non ha funzionato.";
      break;
    case "ERROR_500_SUB":
      localized =
        language === "ENG"
          ? 'Try refreshing the page or click "OK" to return to your orders.'
          : 'Siamo spiacenti. Prova a ricaricare la pagina o clicca su "OK" per tornare ai tuoi ordini.';
      break;
    case "403_LOGOUT_CTA":
      localized = language === "ENG" ? "Back to login" : "Vai alla login";
      break;
    case "500_FAQ_CTA_1":
      localized =
        language === "ENG"
          ? "The portal is optimized for navigation with Google Chrome browser, available for all devices."
          : "Il portale è ottimizzato per la navigazione con browser Google Chrome, disponibile per tutti i dispositivi.";
      break;
    case "500_FAQ_CTA_2":
      localized =
        language === "ENG"
          ? "To try to resolve the problem, consult this short guide."
          : "Per provare a risolvere il problema consulta questa breve guida.";
      break;
    case "500_FAQ_LINK":
      localized = language === "ENG" ? "click here" : " clicca qui";
      break;
    case "MAINTENANCE_TITLE":
      localized =
        language === "ENG"
          ? "We are under Maintenance"
          : "Pagina in Manutenzione";
      break;
    case "MAINTENANCE_SUB":
      localized =
        language === "ENG"
          ? "We are improving our website. We'll be back on with new cool features."
          : "Stiamo migliorando il nostro sito web. Torneremo con nuove funzionalità.";
      break;
    case "MAINTENANCE_SOCIAL_CTA":
      localized =
        language === "ENG"
          ? "In the meantime, visit our social channels to discover the latest news on the Herno world"
          : "Nel frattempo, visita i nostri canali social per scoprire le ultime novità sul mondo Herno";
      break;
    case "MAINTENANCE_RELOAD_CTA":
      localized = language === "ENG" ? "Reload the page" : "Ricarica la pagina";
      break;
    case "Selezionare almeno una categoria": {
      localized =
        language === "ENG" ? "SELECT A FILTER" : "SELEZIONARE ALMENO UN FILTRO";
      break;
    }
    case "Spese di spedizione":
      localized = language === "ENG" ? "Shipping fees" : "Spese di spedizione";
      break;
    case "Seleziona":
      localized = language === "ENG" ? "Select" : "Seleziona";
      break;
    case "Privacy":
      localized = language === "ENG" ? "Privacy" : "Privacy";
      break;
    case "Cookie":
      localized = language === "ENG" ? "Cookie" : "Cookie";
      break;
    case "MAX_QUANTITY_SETTED":
      localized =
        language === "ENG"
          ? "Insufficient quantity in stock.\nThe maximum available has been entered."
          : "Quantità in magazzino insufficiente.\n\u00C8 stato inserito il massimo disponibile";
      break;
    case "MAX_QUANTITY_SETTED_SWAP":
      localized =
        language === "ENG"
          ? "Insufficient quantity purchased.\nThe maximum available has been entered."
          : "Quantità acquistata insufficiente.\n\u00C8 stato inserito il massimo disponibile";
      break;
    case "MAX_QUANTITY_SETTED_NO_ALLOCATION":
      localized =
        language === "ENG"
          ? "Available stock already allocated on other doors"
          : "Disponibilità già allocata sulle altre door";
      break;
    case "CAMBIA AGENTE":
      localized = language === "ENG" ? "CHANGE AGENT" : "CAMBIA AGENTE";
      break;
    case "CAMBIA CLIENTE":
      localized = language === "ENG" ? "CHANGE CUSTOMER" : "CAMBIA CLIENTE";
      break;
    case "I miei ordini":
      localized = language === "ENG" ? "My orders" : "I miei ordini";
      break;
    case "Ordini in bozza":
      localized = language === "ENG" ? "Draft Order" : "Ordine in bozza";
      break;
    case "Nuovo Ordine":
      localized = language === "ENG" ? "New Order" : "Nuovo Ordine";
      break;
    case "Inaffidabili":
      localized = language === "ENG" ? "Unreliable" : "Inaffidabili";
      break;
    case "Bloccati":
      localized = language === "ENG" ? "Blocked" : "Bloccati";
      break;
    case "Riordina":
      localized = language === "ENG" ? "Order again" : "Riordina";
      break;
    case "Swap":
      localized = language === "ENG" ? "Swap" : "Reso";
      break;
    case "Annulla":
      localized = language === "ENG" ? "Cancel" : "Annulla";
      break;
    case "Prossimo":
      localized = language === "ENG" ? "Next" : "Avanti";
      break;
    case "Salva":
      localized = language === "ENG" ? "Save" : "Salva";
      break;
    case "Codice modello":
      localized = language === "ENG" ? "Model code" : "Codice modello";
      break;
    case "Codice modello_Order":
      localized = language === "ENG" ? "Model code: " : "Codice modello: ";
      break;
    case "QTA":
      localized = language === "ENG" ? "QTY" : "QTA";
      break;
    case "TOTALE":
      localized = language === "ENG" ? "TOTAL" : "TOTALE";
      break;
    case "Codice collezione":
      localized = language === "ENG" ? "Collection code" : "Codice collezione";
      break;
    case "Codice collezione_Order":
      localized =
        language === "ENG" ? "Collection code: " : "Codice collezione: ";
      break;
    case "Linea":
      localized = language === "ENG" ? "Line" : "Linea";
      break;
    case "Collezione":
      localized = language === "ENG" ? "Collection" : "Collezione";
      break;
    case "Linea_Order":
      localized = language === "ENG" ? "Line: " : "Linea: ";
      break;
    case "Collezione_Order":
      localized = language === "ENG" ? "Collection: " : "Collezione: ";
      break;
    case "Ordine N°":
      localized = language === "ENG" ? "Order N°" : "Ordine N°";
      break;
    case "Codice cliente":
      localized = language === "ENG" ? "Customer code" : "Codice cliente";
      break;
    case "Nome":
      localized = language === "ENG" ? "Name" : "Nome";
      break;
    case "Tipo":
      localized = language === "ENG" ? "Type" : "Tipo";
      break;
    case "Stagione":
      localized = language === "ENG" ? "Season" : "Stagione";
      break;
    case "Porta":
      localized = language === "ENG" ? "Door" : "Door";
      break;
    case "ORDER_DATE":
      localized = language === "ENG" ? "Order date" : "Data ordine";
      break;
    case "ORDER_DRAFT_DATE":
      localized = language === "ENG" ? "Order date" : "Data ordine";
      break;
    case "ORDER_STATUS_LEGEND_TITLE":
      localized = language === "ENG" ? "ORDER STATUSES" : "STATI ORDINE";
      break;
    case "ORDER_STATUS_DRAFT_LEGEND":
      localized = 
        language === "ENG" 
          ? "Order not yet submitted. You can still edit or complete it within 48h" 
          : "Ordine non ancora trasmesso. Puoi ancora modificarlo o completarlo entro 48h";
      break;
    case "ORDER_STATUS_SUBMITTED_LEGEND":
      localized = 
        language === "ENG" 
          ? "Order successfully submitted. Awaiting confirmation" 
          : "Ordine inviato correttamente. In attesa di conferma";
      break;
    case "ORDER_STATUS_CONFIRMED_LEGEND":
      localized = 
        language === "ENG" 
          ? "Order confirmed and being prepared" 
          : "Ordine confermato e in preparazione";
      break;
    case "ORDER_STATUS_CANCELLED_LEGEND":
      localized = 
        language === "ENG" 
          ? "Order cancelled" 
          : "Ordine annullato";
      break;

    case "ORDER_BUSINESS_NAME":
      localized = language === "ENG" ? "Business Name" : "Ragione Sociale";
      break;
    case "Stato":
      localized = language === "ENG" ? "Status" : "Stato";
      break;
    case "Visualizza carrello":
      localized =
        language === "ENG" ? "Proceed To Checkout" : "Visualizza carrello";
      break;
    case "Carrello vuoto 1":
      localized =
        language === "ENG"
          ? "YOUR SHOPPING CART IS EMPTY."
          : "IL TUO CARRELLO \n\u00C8 VUOTO.";
      break;
    case "Carrello vuoto 2":
      localized =
        language === "ENG"
          ? "You have no items in your cart"
          : "Non hai nessun articolo nel carrello";
      break;
    case "Città":
      localized = language === "ENG" ? "City" : "Città";
      break;
    case "Indirizzo":
      localized = language === "ENG" ? "Address" : "Indirizzo";
      break;
    case "CAP":
      localized = language === "ENG" ? "ZipCode" : "CAP";
      break;
    case "Email":
      localized = language === "ENG" ? "Email" : "Email";
      break;
    case "Telefono":
      localized = language === "ENG" ? "Phone" : "Telefono";
      break;
    case "Visualizza ordine":
      localized = language === "ENG" ? "View order" : "Visualizza ordine";
      break;
    case "Visualizza ordini":
      localized = language === "ENG" ? "View orders" : "Visualizza ordini";
      break;
    case "Affidabili":
      localized = language === "ENG" ? "Reliable" : "Affidabili";
      break;
    case "Tutti":
      localized = language === "ENG" ? "All" : "Tutti";
      break;
    case "Tutti gli stati":
      localized = language === "ENG" ? "All statuses" : "Tutti gli stati";
      break;
    case "Tutti i tipi":
      localized = language == "ENG" ? "All type" : "Tutti i tipi";
      break;
    case "Tutte le stagioni":
      localized = language === "ENG" ? "All seasons" : "Tutte le stagioni";
      break;
    case "Tutte le linee":
      localized = language === "ENG" ? "All lines" : "Tutte le linee";
      break;
    case "QUANTITA'":
      localized = language === "ENG" ? "QUANTITY" : "QUANTIT\u00C0";
      break;
    case "TOTALE RIORDINO":
      localized =
        language === "ENG" ? "TOTAL REORDER" : "TOTALE RIASSORTIMENTO";
      break;
    case "TOTALE RESO":
      localized = language === "ENG" ? "TOTAL RETURN" : "TOTALE RESO";
      break;
    case "Nome modello":
      localized = language === "ENG" ? "Model name" : "Nome modello";
      break;
    case "Codice materiale":
      localized = language === "ENG" ? "Material code" : "Codice materiale";
      break;
    case "Codice linea":
      localized = language === "ENG" ? "Line code" : "Codice linea";
      break;
    case "Descrizione linea":
      localized = language === "ENG" ? "Line description" : "Descrizione linea";
      break;
    case "Descrizione modello":
      localized =
        language === "ENG" ? "Model description" : "Descrizione modello";
      break;
    case "Taglie":
      localized = language === "ENG" ? "Sizes" : "Taglie";
      break;
    case "Descrizione materiale":
      localized =
        language === "ENG" ? "Material description" : "Descrizione materiale";
      break;
    case "Composizione materiale":
      localized =
        language === "ENG" ? "Material composition" : "Composizione materiale";
      break;
    case "Composizione modello":
      localized =
        language === "ENG" ? "Model composition" : "Composizione modello";
      break;
    case "Prezzo":
      localized = language === "ENG" ? "Price" : "Prezzo";
      break;
    case "Seleziona Cliente":
      localized = language === "ENG" ? "Select Customer" : "Seleziona Cliente";
      break;
    case "Collection filter":
      localized = language === "ENG" ? "COLLECTION" : "COLLEZIONE";
      break;
    case "Continuous filter":
      localized = language === "ENG" ? "CARRYOVERS" : "CONTINUATIVO";
      break;
    case "Category filter":
      localized = language === "ENG" ? "CATEGORY" : "CATEGORIA";
      break;
    case "Product type filter":
      localized = language === "ENG" ? "PRODUCT TYPE" : "TIPO PRODOTTO";
      break;
    case "CATALOGUE_FILTER_CLOSURE":
      localized = language === "ENG" ? "CLOSURE" : "CHIUSURA";
      break;
    case "CATALOGUE_FILTER_HOOD":
      localized = language === "ENG" ? "HOOD" : "CAPPUCCIO";
      break;
    case "CATALOGUE_FILTER_PADDING":
      localized = language === "ENG" ? "PADDING" : "IMBOTTITURA";
      break;
    case "CATALOGUE_FILTER_POCKETS":
      localized = language === "ENG" ? "POCKETS" : "TASCHE";
      break;
    case "CATALOGUE_FILTER_REVERSIBLE":
      localized = language === "ENG" ? "REVERSIBLE" : "REVERSIBILE";
      break;
    case "CATALOGUE_FILTER_SLEEVES":
      localized = language === "ENG" ? "SLEEVES" : "MANICA";
      break;
    case "CATEGORY_FILTER_FITTING":
      localized = language === "ENG" ? "FITTING" : "FITTING";
      break;
    case "Color filter":
      localized = language === "ENG" ? "COLOR" : "COLORE";
      break;
    case "Size filter":
      localized = language === "ENG" ? "SIZE" : "TAGLIA";
      break;
    case "Search filter":
      localized = language === "ENG" ? "SEARCH" : "CERCA";
      break;
    case "Search filter2":
      localized = language === "ENG" ? "SEARCH" : "RICERCA";
      break;
    case "USER_FILTERS":
      localized = language === "ENG" ? "FILTERS" : "FILTRI";
      break;
    case "No filter":
      localized =
        language === "ENG" ? "NO FILTER INSERTED." : "NESSUN FILTRO INSERITO.";
      break;
    case "Remove all filter":
      localized = language === "ENG" ? "CLEAR ALL FILTER" : "ELIMINA TUTTI";
      break;
    case "Accedi":
      localized = language === "ENG" ? "Login" : "Accedi";
      break;
    case "Seleziona agente":
      localized = language === "ENG" ? "Select agent" : "Seleziona agente";
      break;
    case "Select user status":
      localized =
        language === "ENG" ? "Select user status" : "Seleziona stato cliente";
      break;
    case "Select agent status":
      localized =
        language === "ENG" ? "Select agent status" : "Seleziona stato agente";
      break;
    case "Client code":
      localized = language === "ENG" ? "Client code" : "Codice cliente";
      break;
    case "Recap incipit":
      localized = language === "ENG" ? " you have" : " hai";
      break;
    case "Recap orders":
      localized = language === "ENG" ? "orders" : "";
      break;
    case "Recap comma":
      localized = language === "ENG" ? "," : ",";
      break;
    case "Recap draft":
      localized = language === "ENG" ? "draft" : "bozza";
      break;
    case "RECAP_DRAFT_SINGULAR":
      localized = language === "ENG" ? "draft" : "bozza";
      break;
    case "RECAP_DRAFT":
      localized = language === "ENG" ? "drafts" : "bozze";
      break;
    case "Recap draft confirmed/singular":
      localized = language === "ENG" ? "Confirmed" : "Confermato";
      break;
    case "Recap draft cancelled/singular":
      localized = language === "ENG" ? "Cancelled" : "Annullato";
      break;
    case "Recap draft confirmed/plural":
      localized = language === "ENG" ? "confirmed" : "confermati";
      break;
    case "Recap draft cancelled/plural":
      localized = language === "ENG" ? "cancelled" : "annullati";
      break;
    case "Recap draft waiting/plural":
      localized = language === "ENG" ? "submitted" : "trasmessi";
      break;
    case "Recap draft waiting/singular":
      localized = language === "ENG" ? "submitted" : "trasmesso";
      break;
    case "RECAP_TYPE_REORDER":
      localized = language === "ENG" ? "Reorder" : "Riordino";
      break;
    case "RECAP_TYPE_SWAP":
      localized = language === "ENG" ? "Swap" : "Sostituzione";
      break;
    case "Mandatory fields":
      localized =
        language === "ENG" ? "* Mandatory fields" : "* Campi obbligatori";
      break;
    case "Order info":
      localized = language === "ENG" ? "Order info" : "Informazioni ordine";
      break;
    case "Info":
      localized = language === "ENG" ? "Info" : "Informazioni";
      break;
    case "Shipping address":
      localized =
        language === "ENG" ? "Shipping address *" : "Indirizzo spedizione *";
      break;
    case "Order type":
      localized = language === "ENG" ? "Order type *" : "Tipo ordine *";
      break;
    case "Order season":
      localized = language === "ENG" ? "Season *" : "Stagione *";
      break;
    case "Order line":
      localized = language === "ENG" ? "Line *" : "Linea *";
      break;
    case "Order Notes":
      localized =
        language === "ENG"
          ? "Note (For personal needs)"
          : "Note (ad uso personale)";
      break;
    case "Select door":
      localized = language === "ENG" ? "Select Door" : "Seleziona Door";
      break;
    case "Select door information":
      localized =
        language === "ENG"
          ? "Only 5 doors selectable"
          : "Selezionare solo 5 porte";
      break;
    case "Approvato":
      localized = language === "ENG" ? "Approved" : "Approvato";
      break;
    case "Non Approvato":
      localized = language === "ENG" ? "Unapproved" : "Non Approvato";
      break;
    case "ADMIN-DRAFT ORDER":
      localized =
        language === "ENG" ? "ADMIN DRAFT ORDER" : "ADMIN ORDINI DRAFT";
      break;
    case "BACK TO LOGIN":
      localized = language === "ENG" ? "BACK TO LOGIN" : "TORNA ALLA LOGIN";
      break;
    case "BACK TO CATALOGUE":
      localized =
        language === "ENG" ? "BACK TO CATALOGUE" : "TORNA AL CATALOGO";
      break;
    case "BACK_TO_CART":
      localized = language === "ENG" ? "Back to cart" : "Torna al Carrello";
      break;

    case "SEND ORDER":
      localized = language === "ENG" ? "SEND ORDER" : "INVIA ORDINE";
      break;
    case "OK":
      localized = language === "ENG" ? "OK" : "OK";
      break;
    case "GO_TO_MY_ORDERS":
      localized =
        language === "ENG" ? 'GO TO "MY ORDERS"' : 'VAI A "I MIEI ORDINI"';
      break;
    case "ORDINE INVIATO CORRETTAMENTE":
      localized =
        language === "ENG"
          ? "ORDER SUBMITTED SUCCESFULLY"
          : "ORDINE TRASMESSO CORRETTAMENTE";
      break;
    case "Max 5 Doors":
      localized = language === "ENG" ? "Max 5 Doors" : "Max 5 Porte";
      break;
    case "TotalOrderSwap":
      localized =
        language === "ENG"
          ? "Difference Reorder - Swap"
          : "Differenza Riassortimento - Reso";
      break;
    case "TotalOrder":
      localized = language === "ENG" ? "Total" : "Totale";
      break;
    case "TotalDoor":
      localized = language === "ENG" ? "Subtotal" : "Totale parziale";
      break;
    case "Continua":
      localized = language === "ENG" ? "Continue Shopping" : "Continua";
      break;
    case "COLORS AVAILABILITY":
      localized =
        language === "ENG" ? "COLORS AVAILABILITY" : "COLORI DISPONIBILI";
      break;
    case "TABMENU_ORDER_STATUS":
      localized = language === "ENG" ? "Order status:" : "Stato ordine:";
      break;
    case "TABMENU_ORDER_DESCRIPTION":
      localized =
        language === "ENG"
          ? "Min is the minimum purchase/return amount. The minimum purchase amount is per door."
          : "Min è l'importo minimo di acquisto/reso. L'importo minimo di acquisto è per door.";
      break;
    case "TABMENU_ORDER_OK":
      localized =
        language === "ENG"
          ? " Order can be sent"
          : "L'ordine può essere inviato.";
      break;
    case "TABMENU_ORDER_WARN":
      localized =
        language === "ENG"
          ? " Order can be sent with shipping costs"
          : " L'ordine può essere inviato con spese di spedizione.";
      break;
    case "TABMENU_ORDER_ERROR":
      localized =
        language === "ENG"
          ? " Order can not be sent"
          : " L'ordine non può essere inviato.";
      break;
    case "TABMENU_MAX":
      localized = language === "ENG" ? "Max:" : "Max:";
      break;
    case "TABMENU_THRESHOLD":
      localized = language === "ENG" ? "Threshold:" : "Soglia Reso:";
      break;
    case "No Doors":
      localized =
        language === "ENG"
          ? "No Door selected (At least one must be selected)"
          : "Nessuna Door selezionata (Almeno una deve essere selezionata)";
      break;
    case "STATUS_WAITING FOR CONFIRMATION":
      localized = language === "ENG" ? "SUBMITTED" : "TRASMESSO";
      break;
    case "STATUS_SUBMITTED":
      localized = language === "ENG" ? "SUBMITTED" : "TRASMESSO";
      break;
    case "STATUS_DRAFT":
      localized = language === "ENG" ? "DRAFT" : "BOZZA";
      break;
    case "STATUS_CANCELLED":
      localized = language === "ENG" ? "CANCELLED" : "ANNULLATO";
      break;
    case "STATUS_CONFIRMED":
      localized = language === "ENG" ? "CONFIRMED" : "CONFERMATO";
      break;
    case "STATUS_CLOSED":
      localized = language === "ENG" ? "CANCELLED" : "ANNULLATO";
      break;

    case "STATUS_C_WAITINGFORCONFIRMATION":
      localized = language === "ENG" ? "Submitted" : "Trasmesso";
      break;
    case "STATUS_C_DRAFT":
      localized = language === "ENG" ? "Draft" : "Bozza";
      break;
    case "STATUS_C_CANCELLED":
      localized = language === "ENG" ? "Cancelled" : "Annullato";
      break;
    case "STATUS_C_CONFIRMED":
      localized = language === "ENG" ? "Confirmed" : "Confermato";
      break;
    case "STATUS_C_CLOSED":
      localized = language === "ENG" ? "Cancelled" : "Annullato";
      break;

    case "DELETEORDER_MESSAGE":
      localized =
        language === "ENG"
          ? "Do you want to delete the order N."
          : "Vuoi cancellare l'ordine N.";
      break;
    case "BACK TO ORDERS":
      localized =
        language === "ENG" ? "BACK TO ORDERS" : "TORNA AI TUOI ORDINI";
      break;
    case "BACK TO CUSTOMERS":
      localized = language === "ENG" ? "BACK TO CUSTOMERS" : "TORNA AI CLIENTI";
      break;
    case "NO ORDERS FOUND":
      localized =
        language === "ENG"
          ? "No order matches your search"
          : "Nessun ordine corrisponde alla tua ricerca.";
      break;
    case "NO ELEMENT FOUND":
      localized =
        language === "ENG" ? "No item found" : "Nessun elemento trovato.";
      break;
    case "DELETEORDER_ITEM_MESSAGE":
      localized =
        language === "ENG"
          ? "Do you want to delete item N."
          : "Vuoi cancellare prodotto N.";
      break;
    case "DELETEORDER_ITEM_MESSAGE_MINICART":
      localized =
        language === "ENG"
          ? "Do you want to delete the item?"
          : "Vuoi cancellare il prodotto?";
      break;

    case "SHAPE":
      localized = language === "ENG" ? "SHAPE: " : "FORMA: ";
      break;
    case "POCKETS":
      localized = language === "ENG" ? "POCKETS: " : "TASCHE: ";
      break;
    case "HOOD":
      localized = language === "ENG" ? "HOOD: " : "CAPPUCCIO: ";
      break;
    case "PADDING":
      localized = language === "ENG" ? "PADDING: " : "IMBOTTITURA: ";
      break;
    case "SLEEVES":
      localized = language === "ENG" ? "SLEEVES: " : "MANICHE: ";
      break;
    case "TAG":
      localized = language === "ENG" ? "TAG: " : "TAG: ";
      break;
    case "FIT":
      localized = language === "ENG" ? "FIT: " : "FIT: ";
      break;
    case "MADEIN":
      localized = language === "ENG" ? "MADE IN: " : "MADE IN: ";
      break;
    case "CLOSURE":
      localized = language === "ENG" ? "CLOSURE: " : "CHIUSURE: ";
      break;
    case "MATERIALDESCRIPTION":
      localized =
        language === "ENG"
          ? "MATERIAL DESCRIPTION: "
          : "DESCRIZIONE MATERIALE: ";
      break;
    case "MORE DESCRIPTION":
      localized = language === "ENG" ? "MORE DETAILS" : "MAGGIORI DETTAGLI";
      break;
    case "MOREDESCRIPTIONNOTFOUND":
      localized = language === "ENG" ? "-" : "-";
      break;
    case "ORDERS IS EMPTY":
      localized =
        language === "ENG" ? "NO ORDERS FOUND" : "NESSUN ORDINE TROVATO";
      break;
    case "AGENTS IS EMPTY":
      localized =
        language === "ENG" ? "NO AGENTS FOUND" : "NESSUN AGENTE TROVATO";
      break;
    case "CUSTOMER IS EMPTY":
      localized =
        language === "ENG" ? "NO CUSTOMER FOUND" : "NESSUN CLIENTE TROVATO";
      break;
    case "CATALOGUE IS EMPTY":
      localized =
        language === "ENG" ? "NO ITEMS FOUND" : "NESSUN PRODOTTO TROVATO";
      break;
    case "CATALOGUE":
      localized = language === "ENG" ? "Catalogue" : "Catalogo";
      break;
    case "Codice Agente":
      localized = language === "ENG" ? "Agent Code: " : "Codice Agente: ";
      break;
    case "COLOR":
      localized = language === "ENG" ? "COLOR" : "COLORE";
      break;
    case "SIZE":
      localized = language === "ENG" ? "SIZE" : "TAGLIA";
      break;
    case "AVAILABILITY":
      localized = language === "ENG" ? "AVAILABILITY" : "DISPONIBILIT\u00C0";
      break;
    case "AVAILABILITY_SWAP":
      localized =
        language === "ENG" ? "Return to vendor" : "Da rendere a Herno";
      break;
    case "SWITCH_ORDER":
      localized =
        language === "ENG"
          ? "ALL 'TO BE REPLACED' ITEMS INCLUDED IN THE CART WILL BE DELETED, CONTINUE?"
          : "TUTTI I CAPI 'DA SOSTITUIRE' INSERITI A CARRELLO VERRANNO ELIMINATI, PROSEGUIRE?";
      break;
    case "STATUS_CUSTOMER":
      localized = language === "ENG" ? "STATUS CUSTOMER" : "STATO CLIENTE";
      break;
    case "SWITCH_PRICE":
      localized = language === "ENG" ? "SHOW PRICES" : "MOSTRA PREZZI";
      break;
    case "SWITCH_PRICE_HIDE":
      localized = language === "ENG" ? "HIDE PRICES" : "NASCONDI PREZZI";
      break;
    case "SWITCH_SWAP":
      localized = language === "ENG" ? "Enable SWAP" : "Abilita RESO";
      break;
    case "SWITCH_SWAP_HIDE":
      localized = language === "ENG" ? "Disable SWAP" : "Disabilita RESO";
      break;
    case "REORDER":
      localized = language === "ENG" ? "REORDER" : "RIASSORTIMENTO";
      break;
    case "SWAP":
      localized = language === "ENG" ? "SWAP" : "SOSTITUZIONE";
      break;
    case "SWAP_TAB":
      localized = language === "ENG" ? "SWAP" : "RESO";
      break;
    case "CART SUMMARY":
      localized = language === "ENG" ? "CART SUMMARY" : "RIEPILOGO CARRELLO";
      break;
    case "RETURN":
      localized = language === "ENG" ? "RETURN" : "RESO";
      break;
    case "RETURN THRESHOLD":
      localized = language === "ENG" ? "RETURN THRESHOLD" : "SOGLIA RESO";
      break;
    case "SHIPPING COST":
      localized = language === "ENG" ? "SHIPPING COST" : "COSTI DI SPEDIZIONE";
      break;
    case "FIRST ROW INFO":
      localized =
        language === "ENG"
          ? "SHIPPING COST BY DOOR:"
          : "COSTO DI SPEDIZIONE A DOOR:";
      break;
    case "SECOND ROW INFO":
      localized =
        language === "ENG"
          ? " Min order amount"
          : " Importo minimo dell'ordine di";
      break;
    case "THIRD ROW INFO":
      localized =
        language === "ENG"
          ? " min order amount Knitwear if present in cart"
          : " importo minimo d'ordine Maglieria se presente nel carrello";
      break;
    case "FOURTH ROW INFO":
      localized =
        language === "ENG"
          ? " min items/pairs of Shoes if present in cart"
          : " min capi/paia di Scarpe se presenti nel carrello";
      break;
    case "MODEL_INFO":
      localized = language === "ENG" ? "Model Info" : "Informazioni Modello";
      break;
    case "CLOSE":
      localized = language === "ENG" ? "CLOSE" : "CHIUDI";
      break;
    case "INFO_MOBILE":
      localized = language === "ENG" ? "INFO" : "DETTAGLI";
      break;
    case "LOST_PWD":
      localized =
        language === "ENG"
          ? "Forgot your password?"
          : "Non ricordi la password?";
      break;
    case "SKU_DESCRIPTION":
      localized =
        language === "ENG" ? "SKU Description: " : "Descrizione SKU: ";
      break;
    case "CODE_COLOR_NOT_FOUND":
      localized =
        language === "ENG"
          ? "The entered color code does not exist"
          : "Il codice colore digitato non esiste";
      break;
    case "not-authorized":
      localized =
        language === "ENG" ? "Unauthorized user." : "Utente non autorizzato.";
      break;
    case "ORDER_NOTES":
      localized = language === "ENG" ? "Notes" : "Note";
      break;
    case "CLEAR_FILTERS":
      localized = language === "ENG" ? "Clear search" : "Elimina ricerca";
      break;
    case "REPORT":
      localized = language === "ENG" ? "View Report" : "Visualizza Report";
      break;
    case "PRINT":
      localized = language === "ENG" ? "Print" : "Stampa";
      break;
    case "DOWNLOAD":
      localized = language === "ENG" ? "Download" : "Scarica";
      break;
    case "VIEW_ORDER":
      localized = language === "ENG" ? "View Order" : "Visualizza ordine";
      break;
    case "EDIT_ORDER":
      localized = language === "ENG" ? "Edit Order" : "Modifica ordine";
      break;
    case "DELETE_ORDER":
      localized = language === "ENG" ? "Delete order" : "Cancella ordine";
      break;
    case "ORDER_CREATED_IN_B2B":
      localized =
        language === "ENG" ? "Order created in B2B" : "Ordine creato in B2B";
      break;
    case "GALLERY":
      localized = language === "ENG" ? "Gallery" : "Galleria immagini";
      break;
    case "GALLERY_360_TOOLTIP":
      localized = language === "ENG" ? "360° view" : "Visualizza 360°";
      break;
    case "GALLERY_EXPAND_TOOLTIP":
      localized = language === "ENG" ? "Expand Image" : "Espandi Immagine";
      break;
    case "CONTINUOUS":
      localized = language === "ENG" ? "Carryovers" : "Continuativo";
      break;
    case "REVERSIBLE":
      localized = language === "ENG" ? "Reversible" : "Reversibile";
      break;
    case "SEARCH":
      localized = language === "ENG" ? "Search" : "Ricerca";
      break;
    case "ACCORDION_SHOW":
      localized = language === "ENG" ? "Show" : "Mostra";
      break;
    case "ACCORDION_HIDE":
      localized = language === "ENG" ? "Hide" : "Nascondi";
      break;
    case "ORDER_EXPAND_ALL_ROWS":
      localized = language === "ENG" ? "Expand all rows" : "Espandi righe";
      break;
    case "ORDER_COLLAPSE_ALL_ROWS":
      localized = language === "ENG" ? "Collapse all rows" : "Collassa righe";
      break;
    case "ORDER_EXPAND_ROW":
      localized = language === "ENG" ? "Expand rows" : "Espandi riga";
      break;
    case "ORDER_COLLAPSE_ROW":
      localized = language === "ENG" ? "Collapse rows" : "Collassa riga";
      break;
    case "ORDER_DELETE_ITEM":
      localized = language === "ENG" ? "Delete item" : "Elimina capo";
      break;
    case "ORDER_DELETE_ITEM_COLOR":
      localized = language === "ENG" ? "Delete color" : "Elimina colore";
      break;
    case "Codice":
      localized = language === "ENG" ? "Code" : "Codice";
      break;
    case "ORDER_DRAFT_BUSINESS_NAME":
      localized = language === "ENG" ? "Business Name" : "Ragione Sociale";
      break;
    case "SAVE_UPDATE_MOBILE":
      localized = language === "ENG" ? "Save" : "Salva";
      break;
    case "ROTATE_MOBILE":
      localized =
        language === "ENG"
          ? "For a better experience, please rotate your device"
          : "Per una migliore esperienza, per favore ruota il tuo dispositivo";
      break;
    case "CATALOGUE_LOAD_MORE_DRAG_CTA":
      localized =
        language === "ENG"
          ? "Click or drag to load more"
          : "Clicca o trascina per mostrare altri";
      break;
    case "CATALOGUE_LOAD_MORE_CLICK_CTA":
      localized =
        language === "ENG"
          ? "Click or scroll down to load more"
          : "Clicca o scrolla verso il basso per caricare altri capi";
      break;
    case "CATALOGUE_BACK_TO_TOP_CTA":
      localized = language === "ENG" ? "Back to top" : "Torna su";
      break;
    case "ORDERS_ORDER_ACCESS_DENIED":
      localized =
        language === "ENG"
          ? "This order is blocked because the selected season is closed."
          : "Questo ordine è stato bloccato per la chiusura della stagione selezionata.";
      break;
    case "CUSTOMERS_NEW_ORDER_FORBIDDEN":
      localized =
        language === "ENG"
          ? "The customer does not fulfill one or more of the following criteria:"
          : "Il cliente non rispetta uno o più dei seguenti criteri:";
      break;
    case "CUSTOMERS_NEW_ORDER_FORBIDDEN_2":
      localized =
        language === "ENG"
          ? "Did not make purchases for the available seasons"
          : "Nessun acquisto effettuato per le stagioni abilitate";
      break;
    case "CUSTOMERS_NEW_ORDER_FORBIDDEN_3":
      localized =
        language === "ENG"
          ? "There are no open seasons to create a new order"
          : "Non esistono stagioni aperte per la creazione di un ordine";
      break;
    case "NEW_ORDER_PAGE_FORBIDDEN":
      localized =
        language === "ENG"
          ? "There are no open seasons to create a new order."
          : "Non esistono stagioni aperte per la creazione di un ordine.";
      break;
    case "ORDER_PAGE_FORBIDDEN":
      localized =
        language === "ENG"
          ? "This order is blocked because the selected season is closed."
          : "Questo ordine è stato bloccato per la chiusura della stagione selezionata.";
      break;
    case "ORDER_PAGE_BACK_BUTTON":
      localized =
        language === "ENG" ? 'Back to "My Orders"' : 'Torna a "I miei Ordini"';
      break;
    case "CATALOGUE_COUNT":
      localized = language === "ENG" ? "of" : "su";
      break;
    case "CATALOGUE_ITEMS":
      localized = language === "ENG" ? "items" : "articoli";
      break;
    case "CATALOGUE_ITEMS_SINGLE":
      localized = language === "ENG" ? "item" : "articolo";
      break;
    case "INFO_BUTTON_GO_TO_ORDERS_CTA":
      localized = language === "ENG" ? "Orders list" : "Lista ordini";
      break;
    case "ORDER_HISTORY_ITEM_STATUS_DRAFT":
      localized = language === "ENG" ? "draft" : "bozza";
      break;
    case "ORDER_HISTORY_ITEM_STATUS_WAITING_FOR_CONFIRMATION":
      localized = language === "ENG" ? "submitted" : "trasmesso";
      break;
    case "ORDER_HISTORY_ITEM_STATUS_CONFIRMED":
      localized = language === "ENG" ? "confirmed" : "confermato";
      break;
    case "ORDER_HISTORY_ITEM_STATUS_CLOSED":
      localized = language === "ENG" ? "Cancelled" : "Annullato";
    case "ORDER_HISTORY_ITEM_STATUS_CANCELLED":
      localized = language === "ENG" ? "Cancelled" : "Annullato";
    case "ORDER_HISTORY_ITEM_ORDER_NUMBER":
      localized = language === "ENG" ? "Order No" : "Num. ordine";
      break;
    case "ORDER_HISTORY_ITEM_ORDER_USER":
      localized = language === "ENG" ? "User" : "Utente";
      break;
    case "ORDER_HISTORY_ITEM_ORDER_CUSTOMER":
      localized = language === "ENG" ? "Customer" : "Cliente";
      break;
    case "ORDER_HISTORY_ITEM_ORDER_DATE":
      localized = language === "ENG" ? "Date" : "Data";
      break;
    case "PLUS_OTHER":
      localized = language === "ENG" ? "colors " : "colori";
      break;
    case "PLUS_OTHER_SINGLE":
      localized = language === "ENG" ? "color " : "colore";
      break;
    case "ORDER_EMAIL_ADD":
      localized = language === "ENG" ? "Add" : "Aggiungi";
      break;
    case "ORDER_EMAIL_INVALID_NEW_ADDRESS":
      localized =
        language === "ENG" ? "Invalid address." : "Indirizzo non valido.";
      break;
    case "FIND_YOUR_SIZE":
      localized = language === "ENG" ? "Find your size" : "Trova la tua taglia";
      break;
    case "PURCHASE_ORDER":
      localized = language === "ENG" ? "Purchase order" : "Ordine d'acquisto";
      break;
    case "PURCHARSE_ORDER_TOOLTIP":
      localized =
        language === "ENG"
          ? "Enter the relevant purchase order"
          : "Inserire l'ordine d’acquisto di riferimento";
      break;
    case "PO":
      localized = language === "ENG" ? "PO" : "PO";
      break;
    case "ADD_TO_WISHLIST":
      localized =
        language === "ENG"
          ? "Add to wishlist"
          : "Aggiungi alla lista dei desideri";
      break;
    case "WISHLIST":
      localized = language === "ENG" ? "Wishlist" : "Whishlist";
      break;
    case "NOTIFY_ME":
      localized =
        language === "ENG"
          ? "This object have a notifys actives"
          : "Questo oggetto ha notifiche attive";
      break;
    case "AVAILABLE":
      localized = language === "ENG" ? "Available" : "Disponibili";
      break;
    case "DEBUG":
      localized = language === "ENG" ? "DEBUG" : "DEBUG";
      break;
    case "NOTIFY":
      localized = language === "ENG" ? "Notify" : "Notifica";
      break;
    case "NEW_VERSION_AVAILABLE":
      localized =
        language === "ENG"
          ? "New Version Available"
          : "Nuova versione disponibile";
      break;
    case "VERSION_UPDATE_MESSAGE":
      localized =
        language === "ENG"
          ? "A new version of the application is available"
          : "È disponibile una nuova versione dell'applicazione";
      break;
    case "FROM_VERSION":
      localized = language === "ENG" ? "From" : "Da";
      break;
    case "TO_VERSION":
      localized = language === "ENG" ? "to" : "a";
      break;
    case "UPDATE_NOW":
      localized = language === "ENG" ? "UPDATE NOW" : "AGGIORNA ORA";
      break;
    case "UPDATE_WILL_RELOAD":
      localized =
        language === "ENG"
          ? "The application will reload automatically"
          : "L'applicazione verrà ricaricata automaticamente";
      break;

    default:
      return "";
  }

  return localized;
}
